import React, { useEffect, useMemo, useRef, useState } from "react";
import "./Matching.css";
import { useParams } from "react-router-dom";
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Modal from "@mui/material/Modal";

const nodeRadius = 15; // Increased size of the dot
const columnGap = 10; // Added space between columns

const defaultPairs = [
  {
    id: 1,
    ltype: "text",
    left: "ସେଉ",
    rtype: "image",
    right:
      "https://thinkzonestorage.blob.core.windows.net/thinkzonecontainer/apple.jpg",
  },
  {
    id: 2,
    ltype: "text",
    left: "କଦଳୀ",
    rtype: "image",
    right:
      "https://thinkzonestorage.blob.core.windows.net/thinkzonecontainer/banana.png",
  },
  {
    id: 3,
    ltype: "text",
    left: "ଅଙ୍ଗୁର",
    rtype: "image",
    right:
      "https://thinkzonestorage.blob.core.windows.net/thinkzonecontainer/grapes.png",
  },
  {
    id: 4,
    ltype: "text",
    left: "କମଳା",
    rtype: "image",
    right:
      "https://thinkzonestorage.blob.core.windows.net/thinkzonecontainer/orange.png",
  },
];

let answerArray = [];

const findClosestNode = (nodes, point, threshold = nodeRadius) =>
  nodes.find(
    (node) =>
      Math.abs(point.x - node.x) < threshold &&
      Math.abs(point.y - node.y) < threshold
  );

const sameHorizontal = (p1, p2) => p1 && p2 && p1.y === p2.y;
const sameVertical = (p1, p2) => p1 && p2 && p1.x === p2.x;

const equalsNode = (n1, n2) => n1 && n2 && n1.x === n2.x && n1.y === n2.y;
const equalsEdge = (e1, e2) =>
  equalsNode(e1[0], e2[0]) && equalsNode(e1[1], e2[1]);

const hasEdge = (edges, edge) =>
  edges.some((otherEdge) => equalsEdge(edge, otherEdge));

const addEdge = (edges, edge) => {
  // Check if the left node of the new edge is already connected
  const leftNodeConnected = edges.some(([start]) => equalsNode(start, edge[0]));

  // Check if the right node of the new edge is already connected
  const rightNodeConnected = edges.some(([, end]) => equalsNode(end, edge[1]));

  // If either the left or right node is already connected, don't add the new edge
  if (leftNodeConnected || rightNodeConnected) {
    return false;
  }

  // If neither left nor right node is already connected, add the new edge
  edges.push(edge);
  return true;
};
/*
const renderCanvas = (canvas, leftArr, rightArr) => {
  const ctx = canvas.getContext("2d");
  ctx.canvas.width = 330;
  ctx.canvas.height = 330;

  const { height, width } = ctx.canvas;
  const rowHeight = height / leftArr.length;
  const margin = nodeRadius * 8.0;

  const nodes = [
    ...leftArr.map((_, i) => ({
      id: _.id,
      type: _.type,
      value: _.left,
      x: margin,
      y: i * rowHeight + rowHeight / 2,
    })),
    ...rightArr.map((_, i) => ({
      id: _.id,
      type: _.type,
      value: _.right,
      x: width - margin,
      y: i * rowHeight + rowHeight / 2,
    })),
  ];
  const edges = [];

  let activeNode = null;
  let pointer = null;
  let isDragging = false;

  const getPointerPosition = (e) => {
    const rect = e.target.getBoundingClientRect();
    return { x: e.clientX - rect.left, y: e.clientY - rect.top };
  };

  const onTouchStart = (e) => {
    const touch = e.touches[0];
    pointer = getPointerPosition(touch);
    const closestNode = findClosestNode(nodes, pointer);
    activeNode = closestNode;
    isDragging = true;
  };

  const onTouchMove = (e) => {
    e.preventDefault();
    const touch = e.touches[0];
    pointer = getPointerPosition(touch);
  };

  const onTouchEnd = (e) => {
    e.preventDefault();
    isDragging = false;

    const intentRadius = nodeRadius * 1.5;
    const closestNode = findClosestNode(nodes, pointer, intentRadius);
    if (
      activeNode &&
      closestNode &&
      !equalsNode(activeNode, closestNode) &&
      !sameVertical(activeNode, closestNode)
    ) {
      const edge = [activeNode, closestNode].sort((a, b) => a.x - b.x);
      addEdge(edges, edge);
      activeNode = null;

      //------------------- My code -------------------
      answerArray.push(edge);
      // ----------------------------------------------
    }
  };

  const animate = () => {
    ctx.fillStyle = "yellow"; // Set the desired background color
    ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    // ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

    edges.forEach(([start, end]) => {
      ctx.beginPath();
      ctx.lineWidth = 2;
      ctx.strokeStyle = "black";
      ctx.moveTo(start.x, start.y);
      ctx.lineTo(end.x, end.y);
      ctx.stroke();
    });

    nodes.forEach((node) => {
      ctx.beginPath();
      ctx.arc(node.x, node.y, nodeRadius, 0, Math.PI * 2);
      ctx.fillStyle = equalsNode(node, activeNode) ? "black" : "darkgrey";
      ctx.fill();

      if (node.type === "text") {
        ctx.font = "16px Arial";
        ctx.fillStyle = "black";
        ctx.fillText(node.value, node.x - 70, node.y + 4);
      } else if (node.type === "image") {
        ctx.font = "16px Arial";
        ctx.fillStyle = "black";
        ctx.fillText(
          node.value.substring(node.value.lastIndexOf("/") + 1),
          node.x + 30,
          node.y + 5
        );
        // const img = new Image();
        // img.src = node.value;
        // console.log("img.src: ", img.src);
        // ctx.drawImage(img, node.x - 20, node.y, 100, 100);
      }
    });

    if (isDragging && activeNode) {
      const intentRadius = nodeRadius * 1.5;
      const closestNode = findClosestNode(nodes, pointer, intentRadius);
      const intent = closestNode || pointer;

      ctx.beginPath();
      ctx.lineWidth = 2;
      ctx.strokeStyle = "red";
      ctx.setLineDash([3, 3]);
      ctx.moveTo(activeNode.x, activeNode.y);
      ctx.lineTo(intent.x, intent.y);
      ctx.stroke();
      ctx.setLineDash([]);
    }

    requestAnimationFrame(animate);
  };

  animate();

  return { onTouchStart, onTouchMove, onTouchEnd };
};
*/
const renderCanvas = (canvas, leftArr, rightArr) => {
  const ctx = canvas.getContext("2d");
  ctx.canvas.width = 370;
  ctx.canvas.height = 370;

  const { height, width } = ctx.canvas;
  const rowHeight = height / leftArr.length;
  const margin = nodeRadius * 9.0;

  const nodes = [
    ...leftArr.map((_, i) => ({
      id: _.id,
      type: _.type,
      value: _.left,
      x: margin,
      y: i * rowHeight + rowHeight / 2,
    })),
    ...rightArr.map((_, i) => ({
      id: _.id,
      type: _.type,
      value: _.right,
      x: width - margin,
      y: i * rowHeight + rowHeight / 2,
    })),
  ];
  const edges = [];

  let activeNode = null;
  let pointer = null;
  let isDragging = false;

  let animationRequestId = null; // Store the requestAnimationFrame ID

  const getPointerPosition = (e) => {
    const rect = e.target.getBoundingClientRect();
    return { x: e.clientX - rect.left, y: e.clientY - rect.top };
  };

  const onTouchStart = (e) => {
    const touch = e.touches[0];
    pointer = getPointerPosition(touch);
    const closestNode = findClosestNode(nodes, pointer);
    activeNode = closestNode;
    isDragging = true;

    // Start animation loop if not already running
    if (!animationRequestId) {
      animationRequestId = requestAnimationFrame(animate);
    }
  };

  const onTouchMove = (e) => {
    e.preventDefault();
    const touch = e.touches[0];
    pointer = getPointerPosition(touch);
  };

  const onTouchEnd = (e) => {
    e.preventDefault();
    isDragging = false;

    const intentRadius = nodeRadius * 1.5;
    const closestNode = findClosestNode(nodes, pointer, intentRadius);
    if (
      activeNode &&
      closestNode &&
      !equalsNode(activeNode, closestNode) &&
      !sameVertical(activeNode, closestNode)
    ) {
      const edge = [activeNode, closestNode].sort((a, b) => a.x - b.x);
      addEdge(edges, edge);
      activeNode = null;

      //------------------- My code -------------------
      answerArray.push(edge);
      // ----------------------------------------------
    }
  };

  const animate = () => {
    ctx.fillStyle = "yellow"; // Set the desired background color
    ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    // ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

    edges.forEach(([start, end]) => {
      ctx.beginPath();
      ctx.lineWidth = 2;
      ctx.strokeStyle = "black";
      ctx.moveTo(start.x, start.y);
      ctx.lineTo(end.x, end.y);
      ctx.stroke();
    });

    nodes.forEach((node) => {
      ctx.beginPath();
      ctx.arc(node.x, node.y, nodeRadius, 0, Math.PI * 2);
      ctx.fillStyle = equalsNode(node, activeNode) ? "black" : "darkgrey";
      ctx.fill();

      if (node.type === "text") {
        ctx.font = "16px Arial";
        ctx.fillStyle = "black";
        ctx.fillText(node.value, node.x - 70, node.y + 4);
      } else if (node.type === "image") {
        ctx.font = "16px Arial";
        ctx.fillStyle = "black";
        ctx.fillText(
          node.value.substring(node.value.lastIndexOf("/") + 1),
          node.x + 30,
          node.y + 5
        );

        // const img = new Image();
        // img.src = node.value;

        // //ctx.drawImage(img, node.x + 15, node.y - 25, 50, 50);

        // img.onload = () => {
        //   ctx.drawImage(
        //     img,
        //     // node.x + 15,
        //     // node.y - 25,
        //     // 50,
        //     // 50
        //     node.x + 25,
        //     node.y - nodeRadius,
        //     nodeRadius * 2,
        //     nodeRadius * 2
        //   );
        // };
      }
    });

    if (isDragging && activeNode) {
      const intentRadius = nodeRadius * 1.5;
      const closestNode = findClosestNode(nodes, pointer, intentRadius);
      const intent = closestNode || pointer;

      ctx.beginPath();
      ctx.lineWidth = 2;
      ctx.strokeStyle = "red";
      ctx.setLineDash([3, 3]);
      ctx.moveTo(activeNode.x, activeNode.y);
      ctx.lineTo(intent.x, intent.y);
      ctx.stroke();
      ctx.setLineDash([]);
    }

    // Request next animation frame if still needed
    if (isDragging || edges.length > 0) {
      console.log("1");
      animationRequestId = requestAnimationFrame(animate);
    } else {
      console.log("2");
      animationRequestId = null;
    }
  };

  // Start animation loop
  animationRequestId = requestAnimationFrame(animate);

  return { onTouchStart, onTouchMove, onTouchEnd };
};

const randomize = () => Math.random() - 0.5;

const Matching = () => {
  const canvasRef = useRef();
  const [pairs, setPairs] = useState(defaultPairs);
  const [submissionCorrect, setSubmissionCorrect] = useState(false);
  const [modals, setModals] = useState(false);

  const leftArr = useMemo(
    () =>
      pairs
        .map((pair) => ({
          id: pair.id,
          type: pair.ltype,
          left: pair.left,
        }))
        .sort(randomize),
    [pairs]
  );

  const rightArr = useMemo(
    () =>
      pairs
        .map((pair) => ({
          id: pair.id,
          type: pair.rtype,
          right: pair.right,
        }))
        .sort(randomize),
    [pairs]
  );

  useEffect(() => {
    const { onTouchStart, onTouchMove, onTouchEnd } = renderCanvas(
      canvasRef.current,
      leftArr,
      rightArr
    );

    // Add listeners
    canvasRef.current.addEventListener("touchstart", onTouchStart);
    canvasRef.current.addEventListener("touchmove", onTouchMove);
    canvasRef.current.addEventListener("touchend", onTouchEnd);

    // Cleanup listeners
    return () => {
      canvasRef.current.removeEventListener("touchstart", onTouchStart);
      canvasRef.current.removeEventListener("touchmove", onTouchMove);
      canvasRef.current.removeEventListener("touchend", onTouchEnd);
    };
  }, [canvasRef, leftArr, rightArr]);

  const handleReset = () => {
    // Clear canvas
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Reset pairs state
    setPairs(defaultPairs);
    setSubmissionCorrect(false); // Reset submission correctness
    window.location.reload();
  };
  const [correctans, setCorrectans] = useState(0);
  const [wrongans, setWrongans] = useState(0);

  const handleSubmit = () => {
    // Check if the left and right column IDs match for all pairs
    console.log("answerArray", answerArray);
    if (answerArray.length < defaultPairs.length) alert("Answer all questions");
    else {
      let correctAnswerCount = 0;
      let wrongAnswerCount = 0;
      answerArray.forEach((ans, i) => {
        if (ans[0].id == ans[1].id) correctAnswerCount += 1;
        else wrongAnswerCount += 1;
      });

      setCorrectans(correctAnswerCount);
      // setWrongans(wrongAnswerCount);
      setModals(true);
      // alert(
      //   "Coorect: " + correctAnswerCount + "    Wrong: " + wrongAnswerCount
      // );

      // submit answerArray
    }
    const correct = pairs.every((pair) => pair.id === pair.right.id);

    // Set submission correctness
    setSubmissionCorrect(correct);
  };
  const cancel = () => {
    setModals(false);
    window.location.reload();
  };

  return (
    <>
      <div>
        <canvas ref={canvasRef}></canvas>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-evenly",
          marginRight: "5%",
        }}
      >
        <button
          onClick={handleReset}
          className="ResetButton"
          style={{
            backgroundColor: "white",
            borderRadius: "10px",
            color: "black",
            border: "1px solid black",
          }}
        >
          Reset
        </button>
        <button
          onClick={handleSubmit}
          className="SubmitButton"
          style={{
            backgroundColor: "#0060ca",
            borderRadius: "10px",
            colour: "white",
          }}
        >
          Submit
        </button>
      </div>
      <Modal open={modals} onClose={() => setModals(false)}>
        <Box sx={style}>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <h1>Correct Answer: {correctans}</h1>
          </div>
          <Button
            variant="contained"
            sx={{
              width: 70,
              marginTop: 2,
              marginBottom: 1,
              marginRight: 1,
            }}
            onClick={cancel}
          >
            OK
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default Matching;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  alignItem: "center",
  justfyContent: "center",
};
